import { useQuery } from '@tanstack/react-query';
import type { AppEntry, CatalogResponse } from '@/types/app';

async function fetchApps(): Promise<AppEntry[]> {
  const res = await fetch('/api/apps', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
    signal: AbortSignal.timeout(8_000),
  });
  if (res.status === 401) {
    // AuthGuard перехватит — но на всякий случай кидаем понятную ошибку.
    throw new Error('UNAUTHENTICATED');
  }
  if (!res.ok) {
    throw new Error(`apps: HTTP ${res.status}`);
  }
  const json = (await res.json()) as CatalogResponse;
  return json.apps;
}

/**
 * TanStack Query хук для каталога. Кеш 5 минут — каталог редко меняется,
 * на сервере есть mtime-инвалидация.
 */
export function useApps(enabled = true) {
  return useQuery({
    queryKey: ['apps'],
    queryFn: fetchApps,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
